import { Component, OnInit } from '@angular/core';
import { CommandeLine } from './shared/commande-line';
import { BasketService } from './shared/basket.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ValidationDialogComponent } from './validation-dialog/validation-dialog.component';
import { NotificationService } from '../../notification/shared/notification.service';
import { ActivatedRoute } from '@angular/router';
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-basket',
  templateUrl: './basket.component.html',
  styleUrls: ['./basket.component.scss']
})
export class BasketComponent implements OnInit {

  commandeLines : Array<CommandeLine>;

  load: Subscription = new Subscription();

  constructor(
    private basketService: BasketService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data =>{
      this.commandeLines = data['basket'];
    })
  }

  updateBasket(){
    this.load.unsubscribe();
    this.load = this.basketService.getBasket().subscribe(commandeLines => this.commandeLines = commandeLines);
  }

  valid(){
    const validationDialogRef = this.dialog.open(ValidationDialogComponent);
    validationDialogRef.afterClosed().subscribe(result => {
      if(result === true){
        this.submitBasket();
      }
    }, err => console.log(err), () => {
    });
  }

  private submitBasket(){
    this.basketService.submit().subscribe(
      res => {
        this.dialog.open(ConfirmDialogComponent);
        this.updateBasket();
      }
    );
  }
}
